import {Injectable} from '@angular/core';
import {Observable, of, switchMap} from 'rxjs';
import {AppSettingsService} from 'src/app/services/app-settings.service';
import {HttpService} from 'src/app/services/http.service';
import {AbstractRestService} from 'src/app/shared/types/AbstractRestService';
import {GpBankAccountsTableSearchOptions} from '../components/gp-bank-account-display-table/gp-bank-accounts-table-search-options';
import {SearchOptionsResponse} from 'src/app/shared/models/SearchOptionsResponse.model';
import {UnitApplicationDto} from '../models/unitApplicationDto.model';
import {SearchOptionsRequest} from 'src/app/shared/models/SearchOptionsRequest.model';

@Injectable({
  providedIn: 'root'
})
export class UnitApplicationMsServiceService extends AbstractRestService<any, UnitApplicationDto> {
  protected readonly baseEndpoint$ = this.appSettingsService.localEnv ?
    of('https://localhost:44360/api/UnitApplication/') :
    of('UnitApplication/');

  constructor(protected http: HttpService,
    private appSettingsService: AppSettingsService) {
    super(http);
  }


  getSearchOptionsToQuerystring(options: SearchOptionsRequest): string {
    return super.getSearchOptionsToQuerystring(options);
  }

  public getUnitApplications(options: SearchOptionsRequest): Observable<SearchOptionsResponse<UnitApplicationDto>> {
    var queryString = this.getSearchOptionsToQuerystring(options);
    return this.baseEndpoint$.pipe(
      switchMap(baseEndpoint => this.http.getTyped<SearchOptionsResponse<UnitApplicationDto>>(`${baseEndpoint}` + queryString)));
  }
  public getUnitApplicationsByEntityId(entityId: string): Observable<UnitApplicationDto[]> {
    return this.baseEndpoint$.pipe(
      switchMap(baseEndpoint => this.http.getTyped<UnitApplicationDto[]>(`${baseEndpoint}${entityId}`)));
  }

  public getUnitApplicationForNotifications(): Observable<UnitApplicationDto[]> {
    return this.baseEndpoint$.pipe(
      switchMap(baseEndpoint => this.http.getTyped<UnitApplicationDto[]>(`${baseEndpoint}incomplete-notifications`)));
  }
}
